<template>
	<form class="responsible-form">
		<div prop="name" class="flex-40 mx-1 mb-2">
			<el-input
				placeholder="Nombre responsable de recoger"
				class="qtc-input"
				:style="`background-color:${globalColors.border}`"
				v-model="responsible.name"
			></el-input>
			<span class="error-message" v-if="$v.responsible.name.$invalid">El nombre es requerido</span>
		</div>
		<div prop="name" class="flex-40 mx-1 mb-2">
			<el-input
				placeholder="Apellido responsable de recoger"
				class="qtc-input"
				:style="`background-color:${globalColors.border}`"
				v-model="responsible.lastname"
			></el-input>
			<span class="error-message" v-if="$v.responsible.lastname.$invalid">El apellido es requerido</span>
		</div>
		<div prop="dni" class="flex-40 mx-1 mb-2">
			<el-input
				placeholder="DNI"
				class="qtc-input"
				:style="`background-color:${globalColors.border}`"
				v-model="responsible.dni"
			></el-input>
			<span class="error-message" v-if="!$v.responsible.dni.required">El DNI es requerido</span>
		</div>
		<div prop="phone" class="flex-40 mx-1 mb-2">
			<el-input
				placeholder="Celular"
				class="qtc-input"
				:style="`background-color:${globalColors.border}`"
				v-model="responsible.phone"
			></el-input>
			<span class="error-message" v-if="$v.responsible.phone.$invalid">El teléfono es requerido</span>
		</div>
	</form>	
</template>
<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';

function created() {
	if (this.getResponsibleData) {
		this.responsible = this.getResponsibleData;
	}
	const userLocal = this.getLocalStorage('user-info');
	if (!this.getResponsibleData && userLocal) {
		const { dni, lastname, name, phone } = userLocal;
		this.responsible = { dni, lastname, name, phone };
	}
}

function handlerValidations(newV) {
	this.$store.commit('UPDATE_RESPONSIBLE_VALID_DATA', null);
	if (!newV.$invalid) {
		const responsibleData = {
			responsibleInfo: this.responsible,
			validResponsibleData: true,
		};
		this.$store.commit('UPDATE_RESPONSIBLE_VALID_DATA', responsibleData);
	}
}

function validations() {
	return {
		responsible: {
			dni: { required },
			lastname: { required },
			name: { required },
			phone: { required },
		},
	};
}

function data() {
	return {
		responsible: {
			dni: '',
			lastname: '',
			name: '',
			phone: '',
		},
	};
}

export default {
	name: 'responsible-form',
	computed: {
		...mapGetters([
			'getResponsibleData',
		]),
	},
	created,
	data,
	validations,
	watch: {
		$v: {
			deep: true,
			handler: handlerValidations,
		},
	},
};
</script>
<style lang="scss" scoped>
	.responsible-form {
		display: grid;
    	grid-gap: 1rem;
    	grid-template-columns: repeat(auto-fill, minmax(30rem, 1fr));
	}
</style>



// WEBPACK FOOTER //
// responsibleForm.vue?c82654ea